module.exports = __webpack_public_path__ + "img/story028.37fad2ae.webp";